const PATHS = {
  LOGIN_VOTER_WITH_PASSWORD: '/loginVoterWithPassword',
  LOGIN_VOTER_WITH_GOOGLE: '/loginVoterWithGoogle'
}

module.exports = PATHS;
